import {StyleSheet, View, Text} from 'react-native';
import {Svg, Path} from 'react-native-svg';
import {getIcon} from 'utils/mediafire';
import {colors} from 'config/styles';

export interface FileIconProps {
  id: string;
  type: string;
  name: string;
  large: boolean;
  iconColor?: string;
  viewbox?: string;
  width?: number;
  height?: number;
}

export function FileIcon(props: FileIconProps) {
  const icon = getIcon(props.type, props.name);
  const extension = typeof props?.name === 'string' && props.name.split('.')?.pop();
  const badge = extension ? extension.substring(0, 4).toUpperCase() : 'FILE';
  return (
    <View style={styles.root}>
      <View style={[styles.inner, props.large && styles.large]}>
        <View style={[icon.type === 'folder' ? styles.iconFolder : styles.iconFile]}>
          <Svg
            viewBox={props.viewbox ?? icon.type === 'folder' ? '0 0 35 30' : '0 0 35 40'}
            height={props.height ?? props.large ? 45 : 35}
            width={props.width ?? props.large ? 40 : 30}>
            {icon.vector.map((d,i) =>
              <Path key={i} d={d} fill={props.iconColor}/>
            )}
          </Svg>
          {icon.type !== 'folder' &&
            <View style={[styles.badge, styles[icon.type]]}>
              <Text style={styles.label} numberOfLines={1}>
                {badge}
              </Text>
            </View>
          }
        </View>
      </View>
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
  inner: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
  },
  large: {
    width: 84,
    height: 74,
  },
  iconFile: {
    marginHorizontal: 14,
  },
  iconFolder: {
    marginHorizontal: 14,
  },
  badge: {
    backgroundColor: colors.neutral.black,
    position: 'absolute',
    left: -2,
    top: 6,
  },
  label: {
    fontSize: 8,
    paddingVertical: 1,
    paddingHorizontal: 2,
    fontWeight: '600',
    color: colors.neutral.white,
  },
  file: {
    backgroundColor: colors.files.text,
  },
  folder: {
    backgroundColor: colors.files.text,
  },
  archive: {
    backgroundColor: colors.files.archive,
  },
  audio: {
    backgroundColor: colors.files.audio,
  },
  video: {
    backgroundColor: colors.files.video,
  },
  image: {
    backgroundColor: colors.files.image,
  },
  spreadsheet: {
    backgroundColor: colors.files.spreadsheet,
  },
  pdf: {
    backgroundColor: colors.files.pdf,
  },
  presentation: {
    backgroundColor: colors.files.presentation,
  },
  document: {
    backgroundColor: colors.files.document,
  },
});
